export default __webpack_public_path__ + "media/color/ric-515a329c.svg";